import { Lightning } from '@lightningjs/sdk'

import { Loader } from '../components/Loader/LoaderWrapper'
import { getColor, grey960 } from '../constants/colors'

export default class Loading extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: getColor(grey960),
      flex: {
        alignItems: 'center',
        justifyContent: 'center',
      },
      Spinner: {
        type: Loader,
        width: 112,
        height: 103,
      },
    }
  }
}
